import React from "react";
import { Link, Routes, Route, } from "react-router-dom";
import Home from "../home/Home";
import './nav.css';
import {  } from "firebase/auth";
import LoginPage from "../LoginPage";
import RegisterDocument from "../RegisterDocument";
import RegisterPage from "../RegisterPage";
import ScanQrCode from "../ScanQRCode";
import Sante from "../sante/Sante";
import {FaUserCircle} from "react-icons/fa";
import AddPret from '../AddPert';
import Documents from "../Documents";
import Contact from "../contact/Contact";
import { getAuth, signOut } from "firebase/auth";
import ListPrets from "../ListPrets";
import ResetPassword from "../ResetPassword";
import Test from "../Test";
import { connected, currentUser, setDisconnected } from "../../util/currentUser";
import Client from "../clients/Client";
import ListCotisation from "../admin/ListCotisation";
import MyImageCaptureComponent from "../clients/comment";
import Capture from "../clients/comment";

class Nav extends React.Component{

    constructor(props) {
        super(props);
        this.state= {
            connectedState:false
        }
    }

    componentDidMount() {
        // setInterval(() => {
        //     this.setState({
        //         connectedState: connected
        //     })
        // }, 1000);
    }

    render(){

        const deconnecter = ()=>{
            const auth = getAuth();
            signOut(auth).then(() => {
            // Sign-out successful.
            setDisconnected();
                alert('deconnecter')
            }).catch((error) => {
            // An error happened.
                alert(error)
            });
        }

        return(
            <div >
                <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                    <div className="container-fluid text-primary">
    
                        <p><Link className="navbar-brand text-primary mx-3" to="/">E-Sante</Link></p> 
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
    
                        <div className="collapse navbar-collapse display-navbar" id="navbarText">    
                            <div></div>    
                            <div >
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                    <li  className="nav-item ">
                                        <p ><Link className="nav-link text-primary px-3" to="/">Accueil</Link></p>                    
                                    </li>
                                      
    
                                    <li className="nav-item dropdown">
                                        <p className="nav-link dropdown-toggle text-primary"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Rembourssement
                                        </p>
                                        <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li  className="nav-item">
                                                <p ><Link className="nav-link text-primary px-3" to="/addPret">Faire un pret</Link></p>                    
                                            </li>
                                            <li  className="nav-item">
                                                <p ><Link className="nav-link text-primary px-3" to="/listPret">List des prets</Link></p>    
                                            </li>  
                                        </ul>
                                    </li>
    
                                    <li  className="nav-item">
                                        <p ><Link className="nav-link text-primary px-3" to="/Sante">Sante</Link></p>                    
                                    </li> 
    
                                    <li className="nav-item dropdown">
                                        <p className="nav-link dropdown-toggle text-primary"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Documents
                                        </p>
                                        <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li  className="nav-item">
                                                <p ><Link className="nav-link text-primary px-3" to="/addDocuments">addDocuments</Link></p>                    
                                            </li>
                                            <li  className="nav-item">
                                                <p ><Link className="nav-link text-primary px-3" to="/Documents">Documents</Link></p>                    
                                            </li>
                                        </ul>
                                    </li>
    
                                    <li  className="nav-item">
                                        <p ><Link className="nav-link text-primary px-3" to="/scanCode">Ma Cartes</Link></p>    
                                    </li>                
                            
                                    <li  className="nav-item">
                                        <p ><Link className="nav-link text-primary px-3" to="/Contact">Contact</Link></p>                    
                                    </li> 
                                </ul>
                            </div>
    
                            <div>
                                <ul className= "navbar-nav me-auto mb-2 mb-lg-0" >              
                                    <li  className="nav-item">
                                        <p className="mx-3"><Link className=" btn btn-danger text-white " to="/Connexion">Connexion</Link></p>                    
                                    </li> 
                                </ul>
                            </div>
    
                        </div>
                    </div>
                </nav>
    
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/connexion" element={<LoginPage />} />
                    <Route path="/addDocuments" element={ <RegisterDocument /> }/>
                    <Route path="/Documents" element={ <Documents /> }/>
                    <Route path="/Contact" element={ <Contact /> }/>
                    <Route path="/Sante" element={<Sante />} />
                    <Route path="/capture" element={<Capture />} />
                    <Route path="/scanCode" element={<ScanQrCode />} />
                    <Route path="/addPret" element={<AddPret />} />
                    <Route path="/listPret" element={<ListPrets />} />
                    <Route path="/resetPassword" element={<ResetPassword/>} />
                    <Route path="/cotisation" element={<ListCotisation/>} />
                    <Route path="/test" element={<Test/>} />
                    {/* <Route path="/commande-medoc" element={<CommandeMedoc/>} /> */}
                </Routes>
            </div>
        )
    }
}    
export default Nav;
